import useClipVersions from '@/hooks/useClipVersions';
import { formatVersionTime } from '@/Pages/Clip/ClipPlayer/ClipCustomizer/ClipCustomizerVersioningPanel/utils';

export default function ViewModeBanner() {
  const { viewingVersion, restoringVersion, exitViewMode } = useClipVersions();

  if (!viewingVersion) {
    return null;
  }

  const isRestoring = restoringVersion !== null;
  const timeLabel = formatVersionTime(viewingVersion.created_at);

  return (
    <div
      data-testid="view-mode-banner"
      className="mt-2 flex w-[97%] shrink-0 items-center gap-2 rounded-[10px] border border-[#ffe9d3] bg-[#fff5ec] p-3"
    >
      <p data-testid="view-mode-banner-label" className="flex-1 text-sm font-medium leading-5 text-slate-700">
        {isRestoring ? (
          <>Restoring Version {restoringVersion.displayIndex}… this may take a moment.</>
        ) : (
          <>
            Viewing an older version{timeLabel ? ` from ${timeLabel}` : ''}. To edit the project, return to the latest
            version or restore this version.
          </>
        )}
      </p>
      <button
        data-testid="view-mode-banner-exit"
        onClick={exitViewMode}
        // Exiting mid-restore would drop the banner while the clip is still being rewritten,
        // and its pre-view snapshot has already been consumed by the restore.
        disabled={isRestoring}
        className={`h-6 min-w-[36px] rounded-md border-0 bg-[#fff5ec] p-1 text-xs font-medium leading-[18px] text-orange-600 ${
          isRestoring ? 'pointer-events-none opacity-40' : 'cursor-pointer'
        }`}
      >
        Exit
      </button>
    </div>
  );
}
